import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Cart buttons are always managed client-side, never server-disabled
   */
  updateButtonStates() {
    const { minusButton, plusButton, quantityInput } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    // El regalo automatico no se puede aumentar ni quitar manualmente;
    // el sincronizador del neceser gestiona su presencia y cantidad.
    const isGift = Boolean(this.closest('[data-elixiva-gift-line]'));
    const locked = quantityInput.disabled || isGift;

    // Solo en el carrito: una unidad permite pulsar "-" para quitar
    // el articulo. Se respeta cualquier bloqueo impuesto desde Shopify.
    minusButton.disabled =
      this.serverDisabledMinus || locked || (value <= min && !(value === 1 && min === 1));
    plusButton.disabled =
      this.serverDisabledPlus || locked || (effectiveMax !== null && value >= effectiveMax);
  }

  /**
   * A cantidad 1, usa la eliminacion NATIVA de Horizon, que envia
   * cart/change.js con quantity: 0 y notifica cart:update al neceser.
   * Para valores mayores conserva el comportamiento original.
   */
  decreaseQuantity(event) {
    if (this.refs.minusButton.disabled || this.refs.quantityInput.disabled) return;

    const { min, value } = this.getCurrentValues();
    if (min === 1 && value === 1) {
      event.preventDefault();
      const line = Number(this.refs.quantityInput.dataset.cartLine);
      const cart = this.closest('cart-items-component');
      if (!Number.isSafeInteger(line) || line < 1 ||
          !cart || typeof cart.onLineItemRemove !== 'function' ||
          cart.classList.contains('cart-items-disabled')) return;

      // Bloqueo inmediato frente a dobles clics mientras Horizon procesa.
      this.refs.minusButton.disabled = true;
      cart.onLineItemRemove(line);
      return;
    }

    super.decreaseQuantity(event);
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
